import { ReactNode } from 'react';
import { coreExtensionData } from '@backstage/frontend-plugin-api';
import { SidebarPage } from '@backstage/core-components';
import appPlugin from '@backstage/plugin-app';
import { makeStyles } from '@material-ui/core';
import { TopBar } from './TopBar';

const useStyles = makeStyles(theme => ({
  shell: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    [theme.breakpoints.down('xs')]: { height: 'auto' },
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    [theme.breakpoints.down('xs')]: { overflowY: 'visible' },
    // core-components' Page sizes itself to the viewport (100vh); under the
    // top bar it fills the remaining height, so there is a single scrollbar.
    '& [data-backstage-core-page]': { height: '100%' },
  },
}));

export const ByxLayout = (props: { nav: ReactNode; children: ReactNode }) => {
  const classes = useStyles();

  return (
    <SidebarPage>
      {props.nav}
      <div className={classes.shell}>
        <TopBar />
        <div className={classes.content}>{props.children}</div>
      </div>
    </SidebarPage>
  );
};

/**
 * Same layout as the app plugin (sidebar + routes), with the BYX top bar
 * above the page content.
 */
export const ByxAppLayout = appPlugin.getExtension('app/layout').override({
  factory: (_originalFactory, { inputs }) => [
    coreExtensionData.reactElement(
      <ByxLayout nav={inputs.nav.get(coreExtensionData.reactElement)}>
        {inputs.content.get(coreExtensionData.reactElement)}
      </ByxLayout>,
    ),
  ],
});
